export default __webpack_public_path__ + "static/media/avatar-Three.53b1aa98.svg";